import React from 'react';
import Layout from '../../../components/Layout/Layout';
import Card from '../../../components/Card/Card';
import { FormattedMessage } from 'react-intl';
import Loader from '../../../components/Loader/Loader';
import NewsSearch from '../../../components/News/NewsSearch';

const View = ({
  newsPanes,
  promoPanes,
  newsLoading,
  promoLoading,
  cardHeaderRef,
  navItemsNews,
  navItemsPromo,
  currentPromoTab,
  loadingMoreSpecialOffers,
  loadMoreSpecialOffers,
  handlePromoTabChange,
  currentNewsTab,
  handleNewsTabChange,
  handleSearch,
}) => (
  <Layout className="news-layout" formattedTitle="pages.news.title">
    <Layout.LeftCol className="left-col col">
      <Card.Tabs
        className="card-loading-silent news-page-list"
        title="news.list.title"
        defaultMessage="News"
        activeTab={currentNewsTab}
        onTabChange={handleNewsTabChange}
        additionalElement={<NewsSearch onSearch={handleSearch} />}
        navItems={navItemsNews}
        panes={newsPanes}
        loading={newsLoading}
        innerRef={(el) => (cardHeaderRef = el)}
      />
    </Layout.LeftCol>

    <Layout.RightCol className="right-col col">
      <Card.Tabs
        className="news-promo-wrapper"
        title="news.special.title"
        defaultMessage="Special offers"
        activeTab={currentPromoTab}
        navItems={navItemsPromo}
        panes={promoPanes}
        loading={promoLoading}
        noPadding
        onTabChange={handlePromoTabChange}
      >
        {!promoLoading && (
          <button
            type="button"
            className="btn btn-with-loader position-relative mx-auto mb-4 btn-radius-sm"
            onClick={loadMoreSpecialOffers}
            disabled={loadingMoreSpecialOffers}
          >
            <FormattedMessage id="news.special.load-more" defaultMessage="More special offers" />
            {loadingMoreSpecialOffers && <Loader isInButton small />}
          </button>
        )}
      </Card.Tabs>
    </Layout.RightCol>
  </Layout>
);

export default View;
